import AssociablePermits from './Constructor'

export default AssociablePermits
export { AssociablePermits }
